import script from "./summary.vue?vue&type=script&setup=true&lang=ts"
export * from "./summary.vue?vue&type=script&setup=true&lang=ts"

import "./summary.vue?vue&type=style&index=0&id=936737da&lang=scss&scoped=true"

import exportComponent from "/home/circleci/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-936737da"]])

export default __exports__